export default {
    'stock_adjustment_applied': 'Stock adjustment applied',
    'worth_x_at_cost_the_stock_changes_once_someone': 'Worth {valueMinor} at cost. The stock changes once someone else approves it.',
    'new_stock_adjustment': 'New stock adjustment',
    'correct_a_count_or_write_off_lost_stock_above': 'Correct a count or write off lost stock. Above the approval limit it waits for a second person.',
    'still_needed': 'Still needed:',
    'cancel': 'Cancel',
    'submit_write_off': 'Submit write-off',
    'submit_adjustment': 'Submit adjustment',
    'store': 'Store',
    'remove_every_line_to_change_the_store': 'Remove every line to change the store',
    'select': 'Select…',
    'type': 'Type',
    'stock_lost_or_destroyed_enter_the_quantity_as_a': 'Stock lost or destroyed. Enter the quantity as a positive number; it is taken out.',
    'correct_a_quantity_use_a_plus_sign_to_add_stock': 'Correct a quantity. Use a plus sign to add stock and a minus sign to remove it.',
    'adjustment_correct_a_quantity': 'Adjustment (correct a quantity)',
    'write_off_lost_damaged_expired': 'Write-off (lost, damaged, expired)',
    'no_batches_added_yet_search_above_and_choose': 'No batches added yet. Search above and choose the batches to adjust.',
    'batch': 'Batch',
    'on_hand_cost': 'on hand · cost',
    'quantity_for_x': 'Quantity for {batchNo}',
    'qty_lost': 'Qty lost',
    'qty': '+/− qty',
    'reason_for_x': 'Reason for {batchNo}',
    'reason_required': 'Reason (required)',
    'loss_category_for_x': 'Loss category for {batchNo}',
    'remove_x': 'Remove {batchNo}',
    'that_is_more_than_the': 'That is more than the',
    'shown_on_hand_when_you_searched_the_server': 'shown on hand when you searched. The server refuses it if the stock really is short.',
    'net_effect_at_cost': 'Net effect at cost:',
    'filter_by_status': 'Filter by status',
    'all_requests': 'All requests',
    'transfer_stock': 'Transfer stock',
    'new_adjustment': 'New adjustment',
    'nothing_is_waiting_for_approval_adjustments': 'Nothing is waiting for approval. Adjustments above the approval limit appear here.',
    'no_requests_with_that_status': 'No requests with that status.',
    'number': 'Number',
    'stock_take': 'stock take',
    'lines': 'Lines',
    'value': 'Value',
    'net_at_cost': 'Net at cost',
    'requested': 'Requested',
    'status': 'Status',
    'by': 'by',
    'approve': 'Approve',
    'reject': 'Reject',
    'withdraw': 'Withdraw',
    'adjustment_request': 'Adjustment request',
    'x_raised_x': '{name} · raised {requestedAt}',
    'close': 'Close',
    'loading': 'Loading…',
    'raised_by_a_stock_take': 'raised by a stock take',
    'requested_by': 'Requested by',
    'unknown': 'unknown',
    'value_2': '· value',
    'net': '· net',
    'at_cost': 'at cost',
    'on': 'on',
    'this_request_has_no_lines': 'This request has no lines.',
    'product': 'Product',
    'change': 'Change',
    'unit_cost': 'Unit cost',
    'reason': 'Reason',
    'loss_category': 'Loss category',
    'line': 'line',
    'values_are_quantity_times_the_batch_cost_when': '. Values are quantity times the batch cost when the request was raised.',
    'note': 'Note',
    'optional': 'Optional',
    'quarantined_and_recalled_stock_on_the_shelf': 'Quarantined and recalled stock on the shelf',
    'blocked_batches_cannot_be_sold_issued_or': 'Blocked batches cannot be sold, issued or transferred until they are released.',
    'reprice': 'Reprice',
    'quarantine_recall': 'Quarantine / recall',
    'nothing_is_quarantined_or_recalled_blocked': 'Nothing is quarantined or recalled. Blocked stock appears here until it is released or used up.',
    'expires': 'Expires',
    'on_hand': 'On hand',
    'value_at_cost': 'Value at cost',
    'since': 'Since',
    'release': 'Release',
    'seeing_the_list_of_blocked_stock_needs_the': 'Seeing the list of blocked stock needs the stock.read permission.',
    'nothing_changed': 'Nothing changed',
    'back_in_normal_stock': 'Back in normal stock.',
    'it_can_no_longer_be_sold_issued_or_transferred': 'It can no longer be sold, issued or transferred.',
    'blocked_stock_is_not_sold_issued_or_transferred': 'Blocked stock is not sold, issued or transferred until it is released.',
    'recall': 'Recall',
    'quarantine': 'Quarantine',
    'action': 'Action',
    'which_stock': 'Which stock',
    'chosen_batches': 'Chosen batches',
    'a_lot_in_every_store_product_and_batch_number': 'A lot, in every store (product and batch number)',
    'no_batches_chosen_yet_search_above_and_add_the': 'No batches chosen yet. Search above and add the batches to change.',
    'remove_x_2': 'Remove {title}',
    'this_changes_every_batch_of_that_product_with': 'This changes every batch of that product with that batch number, in every store you can reach.',
    'batch_number': 'Batch number',
    'kept_on_the_batch_history_at_least_3_characters': 'Kept on the batch history. At least 3 characters.',
    'export_cut_short': 'Export cut short',
    'could_not_export': 'Could not export',
    'exports_the_whole_result_not_only_the_page_on': 'Exports the whole result, not only the page on screen',
    'export_csv': 'Export CSV',
    'no_goods_have_been_received_yet_use_receive': 'No goods have been received yet. Use Receive goods when a delivery arrives.',
    'supplier': 'Supplier',
    'supplier_invoice': 'Supplier invoice',
    'total': 'Total',
    'voided': 'Voided',
    'received': 'Received',
    'print_goods_received_note': 'Print goods received note',
    'void': 'Void',
    'void_x': 'Void {number}',
    'void_goods_received': 'Void goods received',
    'the_stock_this_receipt_brought_in_is_taken_back': 'The stock this receipt brought in is taken back out and what was owed to the supplier is reversed. It only works while none of that stock has moved and nothing has been paid or returned against it.',
    'goods_received_voided': 'Goods received voided',
    'inventory': 'Inventory',
    'batches_on_hand_expiry_valuation_and_reordering': 'Batches on hand, expiry, valuation and reordering',
    'all_stores': 'All stores',
    'add_product': 'Add product',
    'new_purchase_order': 'New purchase order',
    'add_supplier': 'Add supplier',
    'new_indent': 'New indent',
    'receive_goods': 'Receive goods',
    'products': 'Products',
    'stock': 'Stock',
    'expiry': 'Expiry',
    'reorder': 'Reorder',
    'valuation': 'Valuation',
    'suppliers': 'Suppliers',
    'purchase_orders': 'Purchase orders',
    'goods_received': 'Goods received',
    'ward_indents': 'Ward indents',
    'search_by_name_brand_or_code': 'Search by name, brand or code',
    'no_products_yet_add_what_you_sell_here_first': 'No products yet. Add what you sell here first — goods received and sales both pick from this list.',
    'code': 'Code',
    'pack': 'Pack',
    'available': 'Available',
    'reorder_at': 'Reorder at',
    'flags': 'Flags',
    'available_stock_is_at_or_below_the_reorder_level': 'Available stock is at or below the reorder level',
    'low_stock': 'low stock',
    'prescription': 'prescription',
    'controlled': 'controlled',
    'edit': 'Edit',
    'search_by_name_code_or_barcode': 'Search by name, code or barcode',
    'no_stock_matches': 'No stock matches.',
    'item': 'Item',
    'cost': 'Cost',
    'retail': 'Retail',
    'expiring_in_x_days': 'Expiring in {window} days',
    'showing_these_click_again_to_hide': 'Showing these — click again to hide',
    'x_at_cost_click_to_list': '{valueMinor} at cost · click to list',
    'expiring_within_x_days': 'Expiring within {expiryWindow} days',
    'nothing_falls_in_that_window': 'Nothing falls in that window.',
    'days_left': 'Days left',
    'qty_2': 'Qty',
    'already_expired': 'Already expired',
    'nothing_has_expired_the_fefo_picking_is_doing': 'Nothing has expired — the FEFO picking is doing its job.',
    'expired': 'Expired',
    'loss_at_cost': 'Loss at cost',
    'nothing_is_below_its_reorder_level': 'Nothing is below its reorder level.',
    'daily_use': 'Daily use',
    'cover': 'Cover',
    'suggested_order': 'Suggested order',
    'choose_a_store_to_see_its_reorder_suggestions': 'Choose a store to see its reorder suggestions.',
    'batches': 'Batches',
    'units': 'Units',
    'at_cost_2': 'At cost',
    'at_retail': 'At retail',
    'margin': 'Margin',
    'filter_suppliers_by_status': 'Filter suppliers by status',
    'no_suppliers_match_that_filter': 'No suppliers match that filter.',
    'no_suppliers_yet_add_the_people_you_buy_from': 'No suppliers yet. Add the people you buy from — receiving goods and raising a purchase order both pick from this list.',
    'contact': 'Contact',
    'payment_terms': 'Payment terms',
    'active': 'active',
    'inactive': 'inactive',
    'statement': 'Statement',
    'no_purchase_orders_raised_yet': 'No purchase orders raised yet.',
    'print_purchase_order': 'Print purchase order',
    'no_ward_indents_yet': 'No ward indents yet.',
    'for': 'For',
    'from_store': 'From store',
    'product_updated': 'Product updated',
    'product_added': 'Product added',
    'receive_stock_against_it_next': 'Receive stock against it next',
    'edit_x': 'Edit {value}',
    'add_a_product': 'Add a product',
    'what_it_is_what_it_costs_comes_later_with_the': 'What it is. What it costs comes later, with the batch you buy in.',
    'save_changes': 'Save changes',
    'your_own_short_code_it_appears_on_the_shelf': 'Your own short code — it appears on the shelf label',
    'drug': 'Drug',
    'consumable': 'Consumable',
    'asset': 'Asset',
    'service_item': 'Service item',
    'generic_name': 'Generic name',
    'brand_name': 'Brand name',
    'what_the_customer_asks_for': 'What the customer asks for',
    'form': 'Form',
    'tablet_capsule_syrup_injection': 'tablet, capsule, syrup, injection…',
    'strength': 'Strength',
    '500_mg_5_ml': '500 mg, 5 ml…',
    'sold_as': 'Sold as',
    'tablet_bottle_piece': 'tablet, bottle, piece…',
    'pack_size': 'Pack size',
    'how_many_units_in_one_pack': 'How many units in one pack',
    'manufacturer': 'Manufacturer',
    'tax': 'Tax %',
    'applied_when_it_is_sold': 'Applied when it is sold',
    'warn_when_the_shelf_falls_to_this': 'Warn when the shelf falls to this',
    'needs_a_prescription': 'Needs a prescription',
    'controlled_drug_kept_in_the_register': 'Controlled drug (kept in the register)',
    'supplier_deactivated': 'Supplier deactivated',
    'supplier_reactivated': 'Supplier reactivated',
    'no_new_purchase_order_or_goods_received_note': 'No new purchase order or goods received note can be raised for them',
    'they_can_be_ordered_from_and_received_from_again': 'They can be ordered from and received from again',
    'could_not_change_the_supplier': 'Could not change the supplier',
    'deactivate': 'Deactivate',
    'reactivate': 'Reactivate',
    'indent_approved': 'Indent approved',
    'could_not_approve': 'Could not approve',
    'indent_rejected': 'Indent rejected',
    'could_not_reject': 'Could not reject',
    'issued_to_the_ward': 'Issued to the ward',
    'posted_to_the_patient_bill': 'Posted to the patient bill',
    'could_not_issue': 'Could not issue',
    'reject_this_indent': 'Reject this indent',
    'issue': 'Issue',
    'close_short': 'Close short',
    'purchase_order_cancelled': 'Purchase order cancelled',
    'purchase_order_closed_short': 'Purchase order closed short',
    'cancel_x': 'Cancel {number}',
    'close_x_short': 'Close {number} short',
    'nothing_has_been_received_against_this_order_it': 'Nothing has been received against this order. It will no longer be expected.',
    'what_has_already_been_received_stays_in_stock': 'What has already been received stays in stock. The rest will not be delivered.',
    'keep_order': 'Keep order',
    'cancel_order': 'Cancel order',
    'at_least_3_characters_kept_with_the_order': 'At least 3 characters — kept with the order',
    'purchase_order_raised': 'Purchase order raised',
    'raise_a_purchase_order': 'Raise a purchase order',
    'raise_order': 'Raise order',
    'no_active_supplier_add_or_reactivate_one_on_the': 'No active supplier — add or reactivate one on the Suppliers tab',
    'product_2': 'Product…',
    'cost_unit': 'Cost/unit',
    'add_line': 'Add line',
    'notes': 'Notes',
    'indent_raised': 'Indent raised',
    'waiting_on_pharmacy_approval': 'Waiting on pharmacy approval',
    'raise_a_ward_indent': 'Raise a ward indent',
    'requests_stock_from_a_pharmacy_store_pharmacy': 'Requests stock from a pharmacy store; pharmacy approves and issues it',
    'raise_indent': 'Raise indent',
    'ward': 'Ward',
    'supplier_updated': 'Supplier updated',
    'supplier_added': 'Supplier added',
    'goods_can_now_be_received_against_them': 'Goods can now be received against them',
    'edit_supplier': 'Edit supplier',
    'who_the_stock_is_bought_from_every_goods': 'Who the stock is bought from — every goods receipt and purchase order is raised against one',
    'name': 'Name',
    'made_from_the_name_change_it_if_you_keep_your': 'Made from the name — change it if you keep your own codes',
    'medipak': 'MEDIPAK',
    'contact_person': 'Contact person',
    'phone': 'Phone',
    'email': 'Email',
    'tax_number': 'Tax number',
    'payment_terms_days': 'Payment terms (days)',
    'address': 'Address',
    'still_buying_from_them': 'Still buying from them',
    'stock_is_available_for_sale_immediately': 'Stock is available for sale immediately',
    'the_stock_is_in_check_these_before_the_invoice': 'The stock is in. Check these before the invoice is paid.',
    'done': 'Done',
    'batch_number_and_expiry_are_required_fefo': 'Batch number and expiry are required — FEFO picking depends on them',
    'receive': 'Receive',
    'supplier_invoice_no': 'Supplier invoice no.',
    'against_purchase_order': 'Against purchase order',
    'fills_the_lines_with_what_is_still_to_come': 'Fills the lines with what is still to come',
    'not_against_an_order': 'Not against an order',
    'items': 'Items',
    'add_item': 'Add item',
    'batch_no': 'Batch no.',
    'select_a_product': 'Select a product…',
    'remove': 'Remove',
    'terms_days': 'Terms (days)',
    'on_account': 'On account',
    'not_yet_due': 'Not yet due',
    'overdue': 'Overdue',
    'oldest_due': 'Oldest due',
    'balance': 'Balance',
    'previous': 'Previous',
    'next': 'Next',
    'supplier_payables': 'Supplier payables',
    'what_is_owed_to_suppliers_what_has_been_paid': 'What is owed to suppliers, what has been paid, and goods sent back',
    'your_role_does_not_include_access_to_supplier': 'Your role does not include access to supplier payables.',
    'ageing': 'Ageing',
    'payments': 'Payments',
    'returns': 'Returns',
    'balances_as_of': 'Balances as of',
    'show': 'Show',
    'print_ageing': 'Print ageing',
    'the_ageing_report_could_not_be_loaded': 'The ageing report could not be loaded',
    'tie_to_the_ledger': 'Tie to the ledger',
    'ties_to_ledger_2100': 'Ties to ledger 2100',
    'differs_by_x': 'Differs by {value}',
    'supplier_balances_in_this_report': 'Supplier balances in this report',
    'ledger_2100_from_purchasing_and_payments': 'Ledger 2100 from purchasing and payments',
    'manual_journals_on_2100': 'Manual journals on 2100',
    'ledger_2100_in_total': 'Ledger 2100 in total',
    'the_supplier_balances_should_equal_what': 'The supplier balances should equal what purchasing and payments have posted to account 2100. Manual journals are shown separately and are not part of the comparison.',
    'nothing_is_owed_to_any_supplier_as_of_x_goods': 'Nothing is owed to any supplier as of {asOf}. Goods received on credit will appear here.',
    'payments_and_credits_not_yet_matched_to_goods': 'Payments and credits not yet matched to goods received. A negative figure is an advance: the supplier owes us.',
    'outstanding_goods_received_that_are_past_their': 'Outstanding goods received that are past their due date: receipt date plus the supplier\'s payment terms.',
    'terms': '· terms',
    'days': 'days',
    'advance': 'advance',
    'select_a_supplier': 'Select a supplier…',
    'from': 'From',
    'to': 'To',
    'print_statement': 'Print statement',
    'choose_a_supplier': 'Choose a supplier',
    'their_goods_received_returns_and_payments': 'Their goods received, returns and payments appear here with a running balance.',
    'the_statement_could_not_be_loaded': 'The statement could not be loaded',
    'opening_balance': 'Opening balance',
    'owed_at_the_start_of_the_period': 'Owed at the start of the period',
    'charges': 'Charges',
    'goods_received_and_payments_reversed': 'Goods received and payments reversed',
    'credits': 'Credits',
    'returns_goods_voided_and_payments': 'Returns, goods voided and payments',
    'closing_balance': 'Closing balance',
    'owed_at_the_end_of_the_period': 'Owed at the end of the period',
    'awaiting_approval': 'Awaiting approval',
    'payments_not_yet_in_the_balance': 'Payments not yet in the balance',
    'no_goods_received_returns_or_payments_in_this': 'No goods received, returns or payments in this period.',
    'date': 'Date',
    'document': 'Document',
    'detail': 'Detail',
    'due': 'Due',
    'amount': 'Amount',
    'all_statuses': 'All statuses',
    'pay_supplier': 'Pay supplier',
    'no_x_supplier_payments': 'No {value} supplier payments.',
    'no_supplier_payments_yet_use_pay_supplier_to': 'No supplier payments yet. Use Pay supplier to record one.',
    'mode': 'Mode',
    'reference': 'Reference',
    'reversed': 'reversed',
    'decided_by': 'Decided by',
    'print_payment_voucher': 'Print payment voucher',
    'reverse': 'Reverse',
    'reverse_payment_x': 'Reverse payment {number}',
    'x_to_x_x': '{amountMinor} to {name}, {value}',
    'reverse_payment': 'Reverse payment',
    'the_goods_received_this_payment_settled_become': 'The goods received this payment settled become owed again, and the money is put back into the cash drawer or the bank account it came from.',
    'payment_reversed': 'Payment reversed',
    'payment_approved': 'Payment approved',
    'payment_rejected': 'Payment rejected',
    'approve_and_pay': 'Approve and pay',
    'reject_payment': 'Reject payment',
    'optional_kept_with_the_payment': 'Optional — kept with the payment',
    'waiting_for_approval': 'Waiting for approval',
    'x_x_to_x_is_held_until_an_approver_releases_it': '{number} · {amountMinor} to {supplierName} is held until an approver releases it',
    'supplier_paid': 'Supplier paid',
    'x_x_to_x_x': '{number} · {amountMinor} to {supplierName}{onAccount}',
    'choose_which_goods_received_the_payment_settles': 'Choose which goods received the payment settles, or let the oldest be paid first',
    'none_yet_add_one_on_the_suppliers_tab_of': 'None yet — add one on the Suppliers tab of Inventory',
    'the_cheque_number_or_transfer_reference': 'The cheque number or transfer reference',
    'open_the_transfer_slip': 'Open the transfer slip',
    'could_not_open_the_transfer_slip': 'Could not open the transfer slip',
    'open_the_prescription': 'Open the prescription',
    'not_a_web_link_shown_as_text': 'The customer gave something that is not a web link, so it is shown as text only',
    'goods_received_still_owed': 'Goods received still owed',
    'pay_oldest_first': 'Pay oldest first',
    'choose_a_supplier_to_see_the_goods_received': 'Choose a supplier to see the goods received that are still unpaid.',
    'nothing_is_outstanding_for_this_supplier_a': 'Nothing is outstanding for this supplier. A payment made now is kept on account.',
    'paid': 'Paid',
    'returned': 'Returned',
    'outstanding': 'Outstanding',
    'pay_now': 'Pay now',
    'amount_to_pay_on_x': 'Amount to pay on {number}',
    'full': 'Full',
    'payment': 'Payment',
    'allocated': 'Allocated',
    'unallocated_on_account': 'Unallocated (on account)',
    'a_payment_above_the_approval_limit_is_held': 'A payment above the approval limit is held until someone with approval rights releases it. Whatever is not allocated stays on the supplier\'s account.',
    'return_goods': 'Return goods',
    'no_goods_have_been_returned_to_a_supplier_yet': 'No goods have been returned to a supplier yet.',
    'debit_note': 'Debit note',
    'against': 'Against',
    'credit_note': 'Credit note',
    'stock_cost': 'Stock cost',
    'credited': 'Credited',
    'print_debit_note': 'Print debit note',
    'debit_note_x': 'Debit note {number}',
    'returned_from': 'Returned from',
    'supplier_credit_note': 'Supplier credit note',
    'against_goods_received': 'Against goods received',
    'tax_2': 'Tax',
    'subtotal': 'Subtotal',
    'stock_left_at_cost': 'Stock left at cost',
    'x_credited_to_x': '{totalMinor} credited to {supplierName}',
    'the_goods_have_left_the_store_and_the_supplier': 'The goods have left the store and the supplier has been credited',
    'credited_to_the_supplier': 'Credited to the supplier',
    'return_goods_to_a_supplier': 'Return goods to a supplier',
    'the_stock_leaves_at_cost_and_the_supplier_is': 'The stock leaves at cost and the supplier is credited with a debit note',
    'only_batches_received_from_this_supplier_can_be': 'Only batches received from this supplier can be returned to them',
    'remove_the_batches_below_to_change_the_store': 'Remove the batches below to change the store',
    'supplier_credit_note_no': 'Supplier credit note no.',
    'optional_the_number_on_the_suppliers_own_credit': 'Optional — the number on the supplier\'s own credit note',
    'batches_to_return': 'Batches to return',
    'search_stock_by_name_code_or_barcode_then_press': 'Search stock by name, code or barcode, then press Enter',
    'choose_a_store_first': 'Choose a store first',
    'search_stock': 'Search stock',
    'search': 'Search',
    'no_batches_in_stock_match_that_search_or_they': 'No batches in stock match that search, or they are all added already.',
    'batch_2': '· batch',
    'expires_2': '· expires',
    'each': 'each',
    'showing_the_first': 'Showing the first',
    'batches_narrow_the_search_to_find_others': 'batches — narrow the search to find others.',
    'search_for_a_batch_and_click_it_to_add_it_to': 'Search for a batch and click it to add it to this return.',
    'batch_3': 'batch',
    'on_hand_2': '· on hand',
    'quantity_of_x_batch_x_to_return': 'Quantity of {batch} batch {batchNo} to return',
    'value_at_cost_before_tax_the_debit_note_adds': 'Value at cost, before tax — the debit note adds tax when it is saved',
    'product_chosen': 'Product chosen',
    'it_is_dispensed_against_this_prescription_line': 'It is dispensed against this prescription line',
    'could_not_use_that_product': 'Could not use that product',
    'in_stock': 'in stock',
    'controlled_medicines_are_not_listed_the_doctor': 'Controlled medicines are not listed: the doctor must prescribe them from the formulary.',
    'pharmacy': 'Pharmacy',
    'counter_sales_the_prescription_queue_and_returns': 'Counter sales, the prescription queue and returns',
    'wasfaty_prescription': 'Wasfaty prescription',
    'ask_the_insurer': 'Ask the insurer',
    'counter': 'Counter',
    'prescription_queue': 'Prescription queue',
    'no_prescriptions_waiting': 'No prescriptions waiting.',
    'patient': 'Patient',
    'prescriber': 'Prescriber',
    'medicines': 'Medicines',
    'pending': 'pending',
    'done_2': 'done',
    'change_product': 'Change product',
    'choose_product': 'Choose product',
    'issued': 'Issued',
    'print_dispensing_labels': 'Print dispensing labels',
    'dispense': 'Dispense',
    'prescription_loaded': 'Prescription loaded',
    'check_quantities_then_take_payment': 'Check quantities, then take payment',
    'out_of_stock': 'Out of stock',
    'x_has_none_available_in_this_store': '{genericName} has none available in this store',
    'scan_a_barcode_or_type_a_medicine_name_f3_to': 'Scan a barcode or type a medicine name  ·  F3 to focus, F2 to take payment',
    'nothing_matches_that_in_this_store': 'Nothing matches that in this store.',
    'rx': 'Rx',
    'cart': 'Cart',
    'clear': 'Clear',
    'scan_or_search_to_add_items': 'Scan or search to add items.',
    'customer': 'Customer',
    'leave_blank_for_a_walk_in': 'Leave blank for a walk-in',
    'walk_in_name': 'Walk-in name',
    'dispensing_against_a_prescription': 'Dispensing against a prescription.',
    'detach': 'Detach',
    'take_payment_f2': 'Take payment · F2',
    'sale_x_complete': 'Sale {number} complete',
    'change_x': 'Change: {change}',
    'take_payment': 'Take payment',
    'x_item_s': '{length} item(s)',
    'complete_sale': 'Complete sale',
    'reason_for_discount': 'Reason for discount',
    'required_whenever_a_discount_is_given': 'Required whenever a discount is given',
    'discount_above_your_limit': 'Discount above your limit',
    'amount_due': 'Amount due',
    'includes_tax_x': 'Includes tax {tax}',
    'not_enough_stock_here_for_x': 'Not enough stock in this store for {items}',
    'prices_for_this_prescription_could_not_be_loaded': 'The prices for this prescription could not be loaded',
    'waiting_for_prices_remove_lines_without_a_price': 'Waiting for prices. Remove any line that shows no price before taking payment.',
    'sale_x_is_not_fully_paid': 'Sale {number} is not fully paid',
    'x_is_still_owed_on_this_bill': '{balance} is still owed on this bill. Collect it from the bill in Billing.',
    'payment_mode': 'Payment mode',
    'cash_tendered': 'Cash tendered',
    'short_by_x': 'Short by {value}',
    'change_to_return_x': 'Change to return: {change}',
    'exact_amount': 'Exact amount',
    'run': 'Run',
    'choose_the_period_and_press_run': 'Choose the period and press Run.',
    'the_report_could_not_be_produced': 'The report could not be produced',
    'of': 'of',
    'differs': 'differs',
    'output_vat_charged_on_sales_after_returns': 'Output VAT — charged on sales, after returns',
    'input_vat_paid_on_goods_received_after_returns': 'Input VAT — paid on goods received, after returns to suppliers and goods voided',
    'net_vat_payable': 'Net VAT payable',
    'rate': 'Rate',
    'invoices': 'Invoices',
    'taxable_sales': 'Taxable sales',
    'output_vat': 'Output VAT',
    'returned_taxable': 'Returned taxable',
    'returned_vat': 'Returned VAT',
    'receipts': 'Receipts',
    'received_taxable': 'Received taxable',
    'received_vat': 'Received VAT',
    'return_notes': 'Return notes',
    'net_input_vat': 'Net input VAT',
    'receipts_voided': 'Receipts voided',
    'voided_taxable': 'Voided taxable',
    'voided_vat': 'Voided VAT',
    'posted_by': 'Posted by',
    'counts_as': 'Counts as',
    'other_not_vat': 'Other — not VAT',
    'vat': 'VAT',
    'debit': 'Debit',
    'credit': 'Credit',
    'net_credit': 'Net credit',
    'opening_balance_before_x': 'Opening balance, before {from}',
    'output_vat_posted': 'Output VAT posted',
    'input_vat_posted_reduces_the_balance': 'Input VAT posted (reduces the balance)',
    'other_postings_not_vat': 'Other postings — not VAT',
    'movement_in_the_period': 'Movement in the period',
    'closing_balance_at_x': 'Closing balance, at {to}',
    'the_ledger_does_not_match_the_documents': 'The ledger does not match the documents',
    'output_vat_differs_by': 'Output VAT differs by',
    'and_input_vat_differs_by': 'and input VAT differs by',
    'ledger_minus_documents_look_at_the_ledger': '(ledger minus documents). Look at the ledger postings below for the source that does not agree with its invoices or goods received.',
    'ledger_account': 'Ledger account',
    'agrees_with_the_invoices_and_goods_received_for': 'agrees with the invoices and goods received for this period.',
    'net_vat_payable_two_ways': 'Net VAT payable, two ways',
    'line_2': 'Line',
    'from_invoices_and_goods_received': 'From invoices and goods received',
    'from_ledger_x': 'From ledger {account}',
    'difference': 'Difference',
    'output_vat_by_rate': 'Output VAT by rate',
    'no_sales_with_vat_were_invoiced_in_this_period': 'No sales with VAT were invoiced in this period.',
    'input_vat_by_rate': 'Input VAT by rate',
    'no_goods_were_received_in_this_period': 'No goods were received in this period.',
    'no_goods_received_were_voided_in_this_period': 'No goods received were voided in this period.',
    'ledger_account_x': 'Ledger account {account}',
    'account': 'Account',
    'also_receives_payroll_and_doctor_withholding': 'also receives payroll and doctor withholding tax. That “other” line is not VAT: it is left out of the net VAT payable above and only changes the account’s movement and closing balance.',
    'nothing_was_posted_to_account_x_in_this_period': 'Nothing was posted to account {account} in this period.',
    'category': 'Category',
    'quantity_sold': 'Quantity sold',
    'revenue': 'Revenue',
    'margin_2': 'Margin %',
    'group_by': 'Group by',
    'qty_sold': 'Qty sold',
    'before_tax_after_returns': 'Before tax, after returns',
    'cost_of_goods': 'Cost of goods',
    'batch_cost_at_the_time_of_sale': 'Batch cost at the time of sale',
    'totals_cover_every_row_not_only_this_page': 'Totals cover every row, not only this page',
    'sales_by_product': 'Sales by product',
    'sales_by_category': 'Sales by category',
    'nothing_was_sold_in_this_period': 'Nothing was sold in this period.',
    'movements': 'Movements',
    'quantity': 'Quantity',
    'written_off': 'Written off',
    'expired_on': 'Expired on',
    'written_off_as_expired': 'Written off as expired',
    'at_cost_in_this_period': 'At cost, in this period',
    'all_stock_losses': 'All stock losses',
    'expired_damaged_theft_count_differences_and': 'Expired, damaged, theft, count differences and other',
    'returned_to_suppliers': 'Returned to suppliers',
    'sent_back_as_expired_in_this_period': 'Sent back as expired, in this period',
    'still_on_the_shelf_expired': 'Still on the shelf, expired',
    'losses_by_category': 'Losses by category',
    'no_stock_was_written_off_in_this_period': 'No stock was written off in this period.',
    'no_stock_was_written_off_as_expired_in_this': 'No stock was written off as expired in this period.',
    'movement': 'Movement',
    'net_quantity': 'Net quantity',
    'net_value_at_cost': 'Net value at cost',
    'received_value': 'Received value',
    'sold': 'Sold',
    'to_wards': 'To wards',
    'returned_in': 'Returned in',
    'transfer_in': 'Transfer in',
    'transfer_out': 'Transfer out',
    'adjusted': 'Adjusted',
    'to_supplier': 'To supplier',
    'net_qty': 'Net qty',
    'net_value': 'Net value',
    'on_hand_now': 'On hand now',
    'totals_by_movement_type': 'Totals by movement type',
    'no_stock_moved_in_this_period': 'No stock moved in this period.',
    'by_product': 'By product',
    'no_product_had_any_stock_movement_in_this_period': 'No product had any stock movement in this period.',
    'could_not_print': 'Could not print',
    'at_least_x_characters_kept_with_the_record': 'At least {REASON_MIN_LENGTH} characters — kept with the record',
    'recall_report': 'Recall report',
    'pick_a_product_and_type_a_batch_number_to_see': 'Pick a product and type a batch number to see where that lot came from and everywhere it went.',
    'batch_number_then_press_enter': 'Batch number, then press Enter',
    'run_report': 'Run report',
    'export_movements_csv': 'Export movements (CSV)',
    'held_now': 'Held now',
    'this_batch_is_not_held_in_any_store': 'This batch is not held in any store.',
    'received_from': 'Received from',
    'no_goods_receipt_is_on_record_for_this_batch': 'No goods receipt is on record for this batch.',
    'receipt': 'Receipt',
    'no_movements_yet': 'No movements yet.',
    'where_it_went': 'Where it went',
    'no_sales_issues_or_transfers_on_this_page': 'No sales, issues or transfers on this page.',
    'patient_ward_store_or_supplier': 'Patient, ward, store or supplier',
    'the_export_contains_the_movements_on_this_page': 'The export contains the movements on this page. Use Next to load more, then export again.',
    'no_price_changed': 'No price changed',
    'the_new_prices_were_the_same_as_the_current_ones': 'The new prices were the same as the current ones.',
    'the_new_price_applies_to_the_next_sale': 'The new price applies to the next sale.',
    'reprice_batches': 'Reprice batches',
    'change_the_sale_price_of_batches_on_hand_the': 'Change the sale price of batches on hand. The old and new price are kept on the batch history.',
    'change_prices': 'Change prices',
    'no_batches_chosen_yet_search_above_and_add_the_2': 'No batches chosen yet. Search above and add the batches to reprice.',
    'now': '· now',
    'new_sale_price_for_x': 'New sale price for {batchNo}',
    'return_recorded_the_whole_sale_has_now_been': 'Return recorded. The whole sale has now been returned.',
    'return_recorded': 'Return recorded.',
    'credit_of': 'Credit of',
    'for_2': 'for',
    'lines_2': 'lines',
    'paid_back_to_the_customer': 'Paid back to the customer:',
    'no_money_had_to_be_paid_back_for_this_return': 'No money had to be paid back for this return.',
    'supervisor_approval_needed': 'Supervisor approval needed',
    'this_return_about_x_is_above_the_counter_limit': 'This return, about {creditMinor}, is above the counter limit. A supervisor must sign in to approve it.',
    'approve_and_return': 'Approve and return',
    'supervisor_username': 'Supervisor username',
    'supervisor_password': 'Supervisor password',
    'authenticator_code': 'Authenticator code',
    'only_if_the_supervisor_uses_two_factor_sign_in': 'Only if the supervisor uses two-factor sign-in',
    'the_supervisor_must_be_a_different_person_from': 'The supervisor must be a different person from you. The password is sent once with this return and is not kept.',
    'return_recorded_2': 'Return recorded',
    'credit_x': 'Credit {creditMinor}',
    'sale': 'Sale',
    'this_sale_has_no_lines': 'This sale has no lines.',
    'already_returned': 'Already returned',
    'price': 'Price',
    'line_total': 'Line total',
    'return_quantity': 'Return quantity',
    'nothing_left': 'Nothing left',
    '0_to_x': '0 to {room}',
    'quantity_of_x_to_return': 'Quantity of {description} to return',
    'return_everything_that_is_left': 'Return everything that is left',
    'reason_for_the_return': 'Reason for the return',
    'these_goods_go_back_on_the_shelf_and_can_be': 'These goods go back on the shelf and can be sold again.',
    'these_goods_are_written_off_not_restocked_only': 'These goods are written off, not restocked. Only wrong item and customer refused go back on the shelf.',
    'notes_optional': 'Notes (optional)',
    'enter_a_quantity_on_at_least_one_line': 'Enter a quantity on at least one line.',
    'return_items': 'Return items',
    'find_the_sale': 'Find the sale',
    'the_invoice_number_from_the_receipt_or_the': 'The invoice number from the receipt, or the customer\'s name or MRN',
    'invoice_number': 'Invoice number',
    'search_for_the_sale_the_goods_came_from_its': 'Search for the sale the goods came from. Its lines appear here so you can choose what comes back.',
    'no_pharmacy_sale_matches_that_check_the_invoice': 'No pharmacy sale matches that. Check the invoice number on the receipt.',
    'invoice': 'Invoice',
    'selected': 'Selected',
    'loading_the_sale': 'Loading the sale…',
    'approvals': 'Approvals',
    'stock_take_2': 'Stock take',
    'batch_control': 'Batch control',
    'you_have_counts_that_are_not_saved_leave_this': 'You have counts that are not saved. Leave this tab and lose them?',
    'stock_control': 'Stock control',
    'approve_adjustments_count_the_shelves_and': 'Approve adjustments, count the shelves, and quarantine or reprice batches. Approval thresholds are set in Accounts.',
    'nothing_here_for_your_role': 'Nothing here for your role',
    'stock_control_needs_permission_to_adjust_or': 'Stock control needs permission to adjust or approve stock, run stock counts or manage batches. Ask an administrator if you need one of them.',
    'count_sheet_x_started': 'Count sheet {number} started',
    'new_count_sheet': 'New count sheet',
    'takes_a_snapshot_of_every_batch_on_the_shelf_in': 'Takes a snapshot of every batch on the shelf in the store, ready to be counted.',
    'start_counting': 'Start counting',
    'blind_count': 'Blind count',
    'counters_do_not_see_the_system_quantity_so_they': 'Counters do not see the system quantity, so they count what is on the shelf instead of confirming the book.',
    'line_settled': 'Line settled',
    'x_batch_x_counted_as_x': '{genericName} · batch {batchNo} counted as {qty}',
    'settle_a_disputed_count': 'Settle a disputed count',
    'settle': 'Settle',
    'what_each_counter_found': 'What each counter found',
    'choose_one_to_copy_it_or_recount_the_shelf_and': 'Choose one to copy it, or recount the shelf and type the true figure.',
    'settled_quantity': 'Settled quantity',
    'optional_why_this_figure_was_chosen': 'Optional. Why this figure was chosen.',
    'x_closed': '{number} closed',
    'the_count_matched_the_books_so_there_was': 'The count matched the books, so there was nothing to post.',
    'differences_posted_net_x_at_cost': 'Differences posted: net {netValueMinor} at cost.',
    'worth_x_at_cost_the_stock_changes_once_an': 'Worth {valueMinor} at cost. The stock changes once an approver signs it off.',
    'close_x': 'Close {number}',
    'posts_the_difference_between_what_was_counted': 'Posts the difference between what was counted and what the books say as one stock adjustment.',
    'close_sheet': 'Close sheet',
    'counted': 'counted ·',
    'not_counted': 'not counted',
    'a_sheet_cannot_be_reopened_once_it_is_closed': '. A sheet cannot be reopened once it is closed. Differences above the approval limit wait for an approver before any stock moves.',
    'allow_uncounted_lines': 'Allow uncounted lines',
    'close_anyway_lines_nobody_counted_are_left_out': 'Close anyway. Lines nobody counted are left out and their stock is not changed.',
    'before_closing': 'Before closing:',
    'x_cancelled': '{number} cancelled',
    'nothing_was_adjusted': 'Nothing was adjusted.',
    'keep_counting': 'Keep counting',
    'cancel_sheet': 'Cancel sheet',
    'the_sheet_is_abandoned_and_nothing_is_adjusted': 'The sheet is abandoned and nothing is adjusted. It cannot be reopened; start a new sheet to count again.',
    'filter_by_store': 'Filter by store',
    'all_sheets': 'All sheets',
    'no_count_sheets_match_those_filters': 'No count sheets match those filters.',
    'no_count_sheets_yet_start_one_to_count_a_store': 'No count sheets yet. Start one to count a store against what the books say.',
    'blind': 'blind',
    'open': 'open',
    'snapshot': 'Snapshot',
    'variance': 'Variance',
    'closed': 'Closed',
    'could_not_save_the_counts': 'Could not save the counts',
    'you_have_counts_that_are_not_saved_leave_this_2': 'You have counts that are not saved. Leave this sheet and lose them?',
    'all_count_sheets': 'All count sheets',
    'blind_count_2': 'blind count',
    'snapshot_taken': '· snapshot taken',
    'adjustment': 'Adjustment:',
    'save_counts': 'Save counts',
    'not_counted_2': 'Not counted',
    'counted_2': 'Counted',
    'disputed': 'Disputed',
    'two_counters_disagree_settle_each_one_before': 'Two counters disagree. Settle each one before closing.',
    'count': 'Count',
    'search_name_code_barcode_or_batch_then_press': 'Search name, code, barcode or batch, then press Enter',
    'filter_lines_by_status': 'Filter lines by status',
    'all_lines': 'All lines',
    'type_what_you_count_and_press_enter_to_move': 'Type what you count and press Enter to move down the list. Nothing is sent until you press Save counts.',
    'no_lines_match_that_search_or_filter': 'No lines match that search or filter.',
    'this_sheet_has_no_lines_the_store_had_no_stock': 'This sheet has no lines. The store had no stock on the shelf when it was started.',
    'system': 'System',
    'blind_2': 'Blind',
    'counted_quantity_for_x_batch_x': 'Counted quantity for {genericName} batch {batchNo}',
    'settled': 'Settled:',
    'counted_by': 'Counted by',
    'shortage': 'Shortage',
    'overage': 'Overage',
    'overage_minus_shortage': 'Overage minus shortage',
    'uncounted_lines': 'Uncounted lines',
    'x_matched_exactly': '{matchedLines} matched exactly',
    'show_only_lines_that_differ': 'Show only lines that differ',
    'no_differences_so_far_every_counted_line': 'No differences so far. Every counted line matches what the books expect.',
    'this_sheet_has_no_lines': 'This sheet has no lines.',
    'moved_since_snapshot': 'Moved since snapshot',
    'expected': 'Expected',
    'variance_value': 'Variance value',
    'expected_is_the_snapshot_quantity_plus_whatever': 'Expected is the snapshot quantity plus whatever sold, arrived or moved between the snapshot and the moment the line was counted, so stock that changed while counting does not show as a false difference.',
    'from_x_to_x': 'From {fromStoreId} to {toStoreId}',
    'move_batches_from_one_store_to_another': 'Move batches from one store to another. Quarantined and recalled batches cannot be moved.',
    'transfer': 'Transfer',
    'to_store': 'To store',
    'no_batches_added_yet_search_above_and_choose_2': 'No batches added yet. Search above and choose the batches to move.',
    'on_hand_3': 'on hand',
    'quantity_to_move_for_x': 'Quantity to move for {batchNo}',
    'qty_max_x': 'Qty (max {qtyOnHand})',
    'load_more': 'Load more',
    'rows_x_x': 'Rows {value}–{value2}',
    'no_rows_on_this_page': 'No rows on this page',
    'search_by_product_name_code_barcode_or_batch': 'Search by product name, code, barcode or batch number, then press Enter',
    'no_batches_with_stock_match_that_search': 'No batches with stock match that search.',
    'added': 'Added',
    'more_batches_match_than_are_listed_narrow_the': 'More batches match than are listed. Narrow the search to find the one you want.',
    'search_products_by_name_brand_or_code_then': 'Search products by name, brand or code, then press Enter',
    'no_products_match_that_search': 'No products match that search.',
    'sale_cancelled_cannot_return': 'This sale was cancelled, so there is nothing to return.',
    'sale_estimate_cannot_return': 'This sale is still an estimate and was never charged, so there is nothing to return.',
    'package_covers_part_of_this_sale': 'The patient’s package covers part of this sale ({total}). Collect {due}.',
    'in_package': 'In package',
    'beyond_package': 'Beyond package',
    'x_in_package': '{qty} in package',
    'x_beyond_package': '{qty} beyond package',
    'package_covers_x': 'Package covers {amount}',
    'to_collect': 'To collect',
    'checking_the_patients_package': 'Checking the patient’s package…',
    'x_allowance_left_after_this_sale_y': '{name}: {amount} of the medicines allowance left after this sale',
    'package_could_not_be_checked': 'The package could not be checked just now; the sale will confirm what it covers.',
    'amount_due_changed_collect_x': 'The amount due changed since it was shown. Collect {due}.',
};
//# sourceMappingURL=pharmacy.js.map